<template>
  <el-dialog
    class="info_driver_modal"
    :append-to-body="true"
    title="Паспорт организации "
    :visible="dialogVisible"
    :width="isMobile ? '95%' : '60%'"
    :close-on-click-modal="false"
    @close="closeModal()"
  >
    <div v-if="userOrganization === null">Не выбрана организация</div>
    <div v-if="userOrganization !== null">
      <h2>{{ userOrganization.organization.short_name }}</h2>
      <h3>Данные по пользователю</h3>
      <el-row :span="24">
        <el-col :span="5">ФИО пользователя:</el-col>
        <el-col :span="19">
          {{ checkDataIsset(userOrganization.user.fio) }}
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :span="5">Дата рождения:</el-col>
        <el-col :span="19">
          {{ checkDataIsset(userOrganization.user.birthday) }}
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :span="5">Паспорт:</el-col>
        <el-col :span="19">
          {{ checkDataIsset(userOrganization.user.passport) }}
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :span="5">email:</el-col>
        <el-col :span="19">
          {{ checkDataIsset(userOrganization.user.email) }}
        </el-col>
      </el-row>
      <h3>Файлы по пользователю</h3>
      <el-row :span="24" style="height: 50px">
        <el-col :span="5">Удостоверение личности:</el-col>
        <el-col :span="19">
          <upload-document-modal
            name-document="Паспорт"
            :data-edit="documents.user"
            :source-id="documents.user.sourceId"
            :need-additional="false"
          />
        </el-col>
      </el-row>
      <h3>Данные по организации</h3>
      <el-row :span="24">
        <el-col :span="5">Название банка:</el-col>
        <el-col :span="19">
          {{ checkDataIsset(userOrganization.name_bank) }}
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :span="5">Бик:</el-col>
        <el-col :span="19">{{ checkDataIsset(userOrganization.bik) }}</el-col>
      </el-row>
      <el-row :span="24">
        <el-col :span="5">расчетный счет:</el-col>
        <el-col :span="19">
          {{ checkDataIsset(userOrganization.checking_account) }}
        </el-col>
      </el-row>
      <el-row :span="24">
        <el-col :span="5">кор счет:</el-col>
        <el-col :span="19">
          {{ checkDataIsset(userOrganization.core_account) }}
        </el-col>
      </el-row>
      <h3>Файлы по организации</h3>
      <el-row :span="24" style="height: 50px">
        <el-col :span="5">ИНН:</el-col>
        <el-col :span="19">
          <upload-document-modal
            name-document="ИНН"
            :data-edit="documents.inn"
            :source-id="documents.inn.sourceId"
            :need-additional="false"
          />
        </el-col>
      </el-row>
      <el-row :span="24" style="height: 50px">
        <el-col :span="5">ОГРН:</el-col>
        <el-col :span="19">
          <upload-document-modal
            name-document="ОГРН"
            :data-edit="documents.ogrn"
            :source-id="documents.ogrn.sourceId"
            :need-additional="false"
          />
        </el-col>
      </el-row>
      <accreditation-wrapper
        :entity-id="userOrganization.id"
        link-by-rel="userOrganization"
        @updateStore="updateStore"
      />
    </div>
    <div v-if="userOrganization !== null" slot="footer">
      <el-button type="info" @click="createContragent">
        Сделать контрагентом
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { APPROVEMENTS_AUTO } from '@/store/actions/approvements'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import AccreditationWrapper from '../../components/Accreditation/AccreditationWrapper'
import UploadDocumentModal from '@/components/Upload/UploadDocumentModal'
import { mapMutations } from 'vuex'
const UserOrganizations = RepositoryFactory.get('userOrganizations')
const Contragents = RepositoryFactory.get('contragents')

export default {
  name: 'PassportUserOrganization',
  components: { UploadDocumentModal, AccreditationWrapper },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    inn: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    closeModal: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      userOrganization: null,
      documents: {
        inn: {
          sourceModelName: 'userOrgs',
          sourceId: 0,
          documentType: 'inn',
        },
        ogrn: {
          sourceModelName: 'userOrgs',
          sourceId: 0,
          documentType: 'ogrn',
        },
        user: {
          sourceModelName: 'users',
          sourceId: 0,
          documentType: 'passport',
        },
      },
    }
  },
  watch: {
    id: {
      handler(newVal) {
        if (newVal !== 0) {
          this.getUserOrganization(newVal)
        } else {
          this.user_organizations = null
        }
      },
    },
  },

  methods: {
    ...mapMutations({ setApprovementsAuto: `autos/${APPROVEMENTS_AUTO}` }),
    createContragent() {
      const { organization, user } = this.userOrganization

      if (organization && user && organization.inn && user.login) {
        Contragents.postContragents({
          from_inn: organization.inn,
          from_login: user.login,
        })
          .then(res => {
            const { data } = res

            if (res && data) {
              this.$emit('create', data)
            } else {
              this.$message.warning('Нет данных')
            }
          })
          .catch(e => this.errHandler(e))
      } else {
        this.$message.warning('Нет данных')
      }
    },
    updateStore(data) {
      this.setApprovementsAuto(data)
    },
    checkDataIsset(data) {
      if (data === '' || data === null) {
        return 'не указано'
      }

      return data
    },
    getUserOrganization(id) {
      UserOrganizations.get(id)
        .then(response => {
          this.userOrganization = response.data
          this.documents.user.sourceId = this.userOrganization.user.id
          this.documents.ogrn.sourceId = this.userOrganization.id
          this.documents.inn.sourceId = this.userOrganization.id
        })
        .catch(() => (this.user_organizations = null))
    },
  },
}
</script>
